import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const OrdersWereDisabledModal = props => {
  const { isOpen, toggle, restaurant, reason } = props;
  if (!reason) {
    return null;
  }
  return <Modal isOpen={isOpen} toggle={toggle}>
    <ModalHeader toggle={toggle}>Oops!</ModalHeader>
    <ModalBody>
      <p>Niestety, nie ma możliwości dokończenia tego zamówienia.</p>
      <p>Restauracja {restaurant.name} właśnie chwilowo wstrzymała zamówienia z następującego powodu:</p>
      <div className="mt-2 text-center">{reason.name}</div>
      <div className="mt-2">Wróć później, może sytuacja się zmieni, lub jeżeli jesteś głodny - zobacz <a href="/zamawiaj">listę restauracji</a>, gdzie zamówisz tu i teraz.</div>
    </ModalBody>
  </Modal>
}

export default OrdersWereDisabledModal;
